module.exports = __webpack_public_path__ + "static/media/thumb_template.143adfb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/utils/thumb_template.png
// module id = 603
// module chunks = 0